var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableContainer",staticClass:"pb-1"},[_c('div',{staticClass:"mb-4",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }